export default {
  sections: {
    expected_cashback: 'Du verdienst <highlight>{{value}} Punkte</highlight> mit dieser Bestellung',
  },
  buttons: {
    log_in: 'Einloggen, um mit Punkten zu zahlen',
  },
};
